<div *ngIf="resource && loaded"
     class="h-100"
     app-pspdfkit
     [pspdfkitId]="resource.media.pspdfkitId"
     [allowAnnotations]="!!user"
     [enableDownloadAndPrint]="enableDownloadAndPrint()"
     description="resource.media.description">
</div>
